module.exports = __webpack_public_path__ + "img/rotate_screen.5457154b.gif";